import React, { useState } from 'react';

const ForkOptionsModal = ({ isOpen, onClose, onConfirm, sheetTitle, isOwnSheet = false }) => {
  const [forkType, setForkType] = useState('contribute');

  if (!isOpen) return null;

  const handleSubmit = () => {
    onConfirm({
      isPrivateFork: forkType === 'personal',
      canSubmitMergeRequests: forkType === 'contribute'
    });
    onClose();
  };

  // For own sheets, still show the modal but with different messaging
  if (isOwnSheet) {
    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-md">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Fork Your Own Sheet
          </h3>
          
          <p className="text-sm text-gray-700 mb-6">
            You're about to create a public fork of your sheet "{sheetTitle}".
            This fork will be publicly visible and can receive contributions from other users.
            You can later merge changes between your sheets.
          </p>
          
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onConfirm({ isPrivateFork: false, canSubmitMergeRequests: true });
                onClose();
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Create Public Fork
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Fork "{sheetTitle}"
        </h3>
        
        <p className="text-sm text-gray-700 mb-6">
          How would you like to use this fork?
        </p>
        
        <div className="space-y-4 mb-6">
          <div className="flex items-start">
            <input
              id="contribute"
              name="forkType"
              type="radio"
              value="contribute"
              checked={forkType === 'contribute'}
              onChange={(e) => setForkType(e.target.value)}
              className="mt-1 h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
            />
            <div className="ml-3">
              <label htmlFor="contribute" className="text-sm font-medium text-gray-700">
                Contribute improvements back (Recommended)
              </label>
              <p className="text-sm text-gray-500">
                Create a public fork that can submit changes to the original
              </p>
            </div>
          </div>
          
          <div className="flex items-start">
            <input
              id="personal"
              name="forkType"
              type="radio"
              value="personal"
              checked={forkType === 'personal'}
              onChange={(e) => setForkType(e.target.value)}
              className="mt-1 h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
            />
            <div className="ml-3">
              <label htmlFor="personal" className="text-sm font-medium text-gray-700">
                Personal use only
              </label>
              <p className="text-sm text-gray-500">
                Create a private copy for your own modifications
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Create Fork
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForkOptionsModal;